import React from 'react';
import { HorseLink, TrainerLink } from '../../shared/links/ProfileLink';
import ResultLink from '../../shared/links/ResultLink';
import { formatDate, sortByDate } from '../../utils/date';
import { formatMoney } from '../../utils/money';

const columns = (name, id) => [
    {
        key: 'raceDatetime',
        header: 'date',
        sortFn: sortByDate('raceDatetime'),
        cell: ({ raceDatetime }) => formatDate(raceDatetime, 'DDMMMYY'),
    },
    {
        key: 'raceInstanceUid',
        header: 'race name',
        cell: row => (
            <ResultLink
                {...row}
                courseName={name}
                courseUid={+id}
            />
        ),
    },
    {
        key: 'horseUid',
        header: 'winner',
        cell: HorseLink,
    },
    {
        key: 'trainerUid',
        header: 'trainer',
        cell: TrainerLink,
    },
    {
        key: 'prizeSterling',
        header: 'winnings',
        cell: ({ prizeSterling }) => formatMoney(prizeSterling),
    },
];

export default columns;



// WEBPACK FOOTER //
// ./src/js/course/results/columns.jsx